import DdTransparentButton from '@/components/DdTransparentButton'
import DdCustomButton from '@/components/DdCustomButton'
import DdSubHeader from '@/components/DdSubHeader'
import DdTextArea from '@/components/DdTextArea'
import DdDefaultButton from '@/components/DdDefaultButton'
import DdIconButtonWithTooltip from '@/components/DdIconButtonWithTooltip'
import DdQuillEditor from '@/components/DdQuillEditor'
import DdUriageSummaryDisp from '@/components/DdUriageSummaryDisp'
import DdUriageDayByDayDisp from '@/components/DdUriageDayByDayDisp'
import DdUriageChartDisp from '@/components/DdUriageChartDisp'

// import date from '@/ddv2.library/date'
import flowMixin from '@/mixins/flowMixins'
import filter from '@/rahmen/utils/filters'
import Logger from '@/rahmen/logger'
import effects from '@/rahmen/utils/effects'
import modals from '@/ddv2.library/modals'
import date from '@/ddv2.library/date'
import indexeddb from '@/ddv2.library/indexeddb'
// import validators from '@/rahmen/validators'

import VueMarkdown from 'vue-markdown'
import { mapGetters } from 'vuex'

const DdDateBox = () => import('@/components/DdDateBox')
const DdDropDown = () => import('@/components/DdDropDown')
const DdTextBox = () => import('@/components/DdTextBox')

const SYSTEM_MESSAGE = '10'
const COMPANY_MESSAGE = '20'
const IMPORTAMT = '10'

export default {
  name: 'DashBoard',
  mixins: [flowMixin],
  components: {
    DdTransparentButton,
    DdCustomButton,
    DdSubHeader,
    DdTextArea,
    DdDefaultButton,
    DdIconButtonWithTooltip,
    DdQuillEditor,
    DdUriageSummaryDisp,
    DdUriageDayByDayDisp,
    DdUriageChartDisp,
    DdDateBox,
    DdDropDown,
    DdTextBox,
    VueMarkdown
  },
  data: () => ({
    exPanel1: [0],
    tab: [
      { href: '#tab1', value: 'お知らせ' },
      { href: '#tab2', value: 'システムからのお知らせ' },
      { href: '#tab3', value: 'オイル交換のお知らせ' },
      { href: '#tab4', value: '車検のお知らせ' },
      { href: '#tab5', value: '免許更新のお知らせ' }
    ],

    // お知らせ編集用
    rec: {},

    // 売上用
    uriageTargetYmd: null,
    uriageTargetYmList: [],
    uriageTargetYmIndex: 12,

    // チャート用
    uriageTargetYm: null,

    isHide: true,
    OshiraseUpdateButtonDisp: false,
    SystemOshiraseUpdateButtonDisp: false,
    currentDate: null,
    targetYmdType: '01',
    isNewInfo1: false,
    isNewInfo2: false,

    showSystemOshirase: false,
    oshiraseList: [],

    editorOption: {
      theme: 'bubble',
      placeholder: '',
      modules: {
        toolbar: []
      }
    },

    dashDashBoardDisp: false,
    modeKengen: 0
  }),
  computed: {
    ...mapGetters({
      userId: 'users/userId',
      currentKaishaCode: 'users/currentKaishaCode',
      kengenGroupCd: 'users/kengenGroupCd',
      menuList: 'DDMasters/menuList',
      jininList: 'DDMasters/mstJinin',
      menkyoshoList: 'DDMasters/mstMenkyosho',
      sharyoList: 'DDMasters/vwCMstSharyo',
      kubunList: 'DDMasters/msysKubun',
      userSettings: 'DDMasters/mstUserSettings',
      helpUseFlg: 'users/helpUseFlg',
      systemConfigList: 'DDMasters/msysSystemConfig',
      currentKinoId: 'system/currentKinoId',
      currentKengenGroupCd: 'users/kengenGroupCd'
    }),
    oftenUseMenuList () {
      return this.menuList.filter((t) => {
        return t.oftenUseFlg === true
      })
    },
    filteredHasseimotoKbnList () {
      return this.kubunListFilterForDropDownItem(this.kubunList, 'KBNM00')
    },
    filteredTitleList () {
      return this.kubunListFilterForDropDownItem(this.kubunList, 'KBNM01')
    },
    // 社内向けお知らせ
    filteredSloganRows () {
      const target = filter.dateFormatter(date.getCurrentDate())
      const self = this
      const rows = this.oshiraseList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(function (elem) {
        return elem.kaishaCd === self.currentKaishaCode && elem.hasseimotoKbn === '01' && elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target && elem.delFlg === false
      }).sort((elem1, elem2) => {
        // 基本的に1件しかないはず
        if (elem1.tekiyoStartYmdDisp > elem2.tekiyoStartYmdDisp) { return 1 }
        if (elem1.tekiyoStartYmdDisp === elem2.tekiyoStartYmdDisp) { return 0 }
        return -1
      })
      return rows
    },
    // 社内向けお知らせ
    filteredOshiraseToWithInCompanyRows () {
      const target = filter.dateFormatter(date.getCurrentDate())
      const self = this
      const rows = this.oshiraseList.map((elem) => {
        var kbnm01 = indexeddb.getKubun(self.currentKaishaCode, self.kubunList, 'KBNM01', elem.title)
        var kbnm00 = indexeddb.getKubun(self.currentKaishaCode, self.kubunList, 'KBNM00', elem.hasseimotoKbn)

        elem.oshiraseSbtNm = kbnm01 ? kbnm01.codeNm : ''
        elem.oshiraseSbtColor = kbnm01 ? kbnm01.komoku1 : 'white'
        elem.hasseimotoKbnNm = kbnm00 ? kbnm00.codeNm : ''
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(function (elem) {
        return elem.kaishaCd === self.currentKaishaCode && elem.hasseimotoKbn === '20' && elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target && elem.delFlg === false
      }).sort((elem1, elem2) => {
        if (elem1.tekiyoStartYmdDisp < elem2.tekiyoStartYmdDisp) { return 1 }
        if (elem1.tekiyoStartYmdDisp === elem2.tekiyoStartYmdDisp) { return 0 }
        return -1
      })
      return rows
    },
    // システムからのお知らせ
    filteredOshiraseFromSystemRows () {
      const target = filter.dateFormatter(date.getCurrentDate())
      const self = this
      const rows = this.oshiraseList.map((elem) => {
        var kbnm01 = indexeddb.getKubun(self.currentKaishaCode, self.kubunList, 'KBNM01', elem.title)
        var kbnm00 = indexeddb.getKubun(self.currentKaishaCode, self.kubunList, 'KBNM00', elem.hasseimotoKbn)

        elem.oshiraseSbtNm = kbnm01 ? kbnm01.codeNm : ''
        elem.oshiraseSbtColor = kbnm01 ? kbnm01.komoku1 : 'white'
        elem.hasseimotoKbnNm = kbnm00 ? kbnm00.codeNm : ''
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(function (elem) {
        return elem.kaishaCd === '****' && elem.hasseimotoKbn === '10' && elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target && elem.delFlg === false
      }).sort((elem1, elem2) => {
        if (elem1.tekiyoStartYmdDisp < elem2.tekiyoStartYmdDisp) { return 1 }
        if (elem1.tekiyoStartYmdDisp === elem2.tekiyoStartYmdDisp) { return 0 }
        return -1
      })
      return rows
    },
    // オイル交換
    mstSharyoOilList () {
      const target = filter.dateFormatter(this.getAfterDay(30))
      return this.sharyoList.map((m) => {
        m.nextOilYmdDisp = filter.dateFormatter(m.nextOilYmd)
        return m
      }).filter((m) => {
        return m.nextOilYmdDisp < target
      })
    },
    isNewInfo3 () {
      if (this.mstSharyoOilList.length > 0) {
        return true
      } else {
        return false
      }
    },
    // 車検
    mstSharyoShakenList () {
      const target = filter.dateFormatter(this.getAfterDay(60))
      return this.sharyoList.map((m) => {
        m.nextShakenYmdDisp = filter.dateFormatter(m.nextShakenYmd)
        m.tekiyoStartYmdDisp = filter.dateFormatter(m.tekiyoStartYmd)
        m.tekiyoEndYmdDisp = filter.dateFormatter(m.tekiyoEndYmd)
        m.alertLevel = 0
        if (m.nextShakenYmdDisp <= this.currentDate) {
          m.alertLevel = 3
        } else if (m.nextShakenYmdDisp <= this.getAfterDaysfromToday(30)) {
          m.alertLevel = 2
        } else if (m.nextShakenYmdDisp <= this.getAfterDaysfromToday(60)) {
          m.alertLevel = 1
        }

        return m
      }).filter((m) => {
        return m.nextShakenYmdDisp < target && m.tekiyoStartYmdDisp <= this.currentDate && m.tekiyoEndYmdDisp >= this.currentDate && m.hacchusakiFlg === false
      }).sort((elem1, elem2) => {
        if (elem1.nextShakenYmdDisp > elem2.nextShakenYmdDisp) { return 1 }
        if (elem1.nextShakenYmdDisp === elem2.nextShakenYmdDisp) { return 0 }
        return -1
      })
    },
    isNewInfo4 () {
      if (this.mstSharyoShakenList.length > 0) {
        return true
      } else {
        return false
      }
    },
    // 免許更新
    mstMenkyoshoList () {
      const target = filter.dateFormatter(this.getAfterDay(60))

      // ① jininCd ごとに yukokigen が最新(最大)の1件だけ残す
      const latestByJinin = Object.values(
        this.menkyoshoList.reduce((acc, m) => {
          const key = m.jininCd

          // yukokigen の比較用（Dateでも文字列でもOK）
          const cur = new Date(m.yukokigen).getTime()
          const prev = acc[key] ? new Date(acc[key].yukokigen).getTime() : -Infinity

          if (!acc[key] || cur > prev) {
            acc[key] = m
          }
          return acc
        }, {})
      )

      // ② 以降は「最新1件だけになったリスト」に対して、今のロジックを適用
      return latestByJinin.map((m) => {
        m.yukokigenDisp = filter.dateFormatter(m.yukokigen)
        m.jininNm = ''

        const ret = this.jininList.filter((t) => {
          return (
            t.jininCd === m.jininCd &&
            t.tekiyoStartYmdString <= target &&
            t.tekiyoEndYmdString >= target
          )
        })
        m.isActiveJinin = ret.length > 0
        if (ret.length > 0 && ret[0].jininNmSei !== '') {
          m.jininNm = ret[0].jininNmSei
        }

        m.alertLevel = 0
        if (m.yukokigenDisp <= this.currentDate) {
          m.alertLevel = 3
        } else if (m.yukokigenDisp <= this.getAfterDaysfromToday(30)) {
          m.alertLevel = 2
        } else if (m.yukokigenDisp <= this.getAfterDaysfromToday(60)) {
          m.alertLevel = 1
        }

        return m
      })
        // 退職済み等、対象期間内に在籍していない人員の免許は通知対象から除外する
        .filter((m) => m.yukokigenDisp < target && m.isActiveJinin)
        .sort((a, b) => (a.yukokigenDisp > b.yukokigenDisp ? 1 : a.yukokigenDisp < b.yukokigenDisp ? -1 : 0))
    },
    isNewInfo5 () {
      if (this.mstMenkyoshoList.length > 0) {
        return true
      } else {
        return false
      }
    },
    // お知らせ件数
    isNewInfo () {
      var notificationCount = this.filteredOshiraseToWithInCompanyRows.length + this.filteredOshiraseFromSystemRows.length + this.mstSharyoOilList.length + this.mstSharyoShakenList.length + this.mstMenkyoshoList.length
      this.$store.dispatch('system/setNotificationCount', notificationCount)
      this.$store.dispatch('system/setAdminNotificationCount', this.filteredOshiraseToWithInCompanyRows.length)
      this.$store.dispatch('system/setSystemNotificationCount', this.filteredOshiraseFromSystemRows.length)
      this.$store.dispatch('system/setCarNotificationCount', this.mstSharyoOilList.length + this.mstSharyoShakenList.length)
      this.$store.dispatch('system/setLicenceNotificationCount', this.mstMenkyoshoList.length)
      return this.isNewInfo1 || this.isNewInfo2 || this.filteredOshiraseToWithInCompanyRows.length > 0 || this.filteredOshiraseFromSystemRows.length > 0 || this.mstSharyoOilList.length > 0 || this.mstSharyoShakenList.length > 0 || this.mstMenkyoshoList.length > 0
    },
    // 売上用
    targetUriageYm () {
      if (this.uriageTargetYmList.length === 0) return ''
      const dt = this.uriageTargetYmList[this.uriageTargetYmIndex].split('/')
      return dt[0] + '年' + dt[1] + '月'
    }
  },
  created () {
    effects.loadStart()
    this.$store.dispatch('system/setViewTitle', 'トップメニュー')
    console.log('DashBoard.Created', this.$router)
    this.initialize()
    // package_dev側は不要
    // this.getUsanaviInfo()
  },
  mounted () {
    this.logger = new Logger('token', 'name')
    this.logger.debug('DashBoard.mounted', { loginId: this.loginId, password: this.password })
    window.setTimeout(effects.loadComplete, 1000)
    this.initialize()
    this.settingButtonState()
  },
  methods: {
    initialize: function (e) {
      console.log('initialize')
      effects.loadStart()
      this.currentDate = date.getCurrentDate()
      this.uriageTargetYmd = this.currentDate
      const targetYmdType = this.getSystemConfigInfo()
      this.targetYmdType = targetYmdType
      for (let i = 12; i >= -84; i--) {
        const ymd = (this.monthAdd(i, this.currentDate)).split('/')
        const ym = ymd[0] + '/' + ymd[1]
        this.uriageTargetYmList.push(ym)
      }

      const self = this
      this.$store.dispatch('DDMasters/loadMasters', { list: ['mstjinin', 'mstmenkyosho', 'vwcmstsharyo', 'msyskubun'], version: 1 }).then(() => {
        self.HttpClient.get('/api/v1/MsysMenuOshirase/GetAll', null).then((data) => {
          self.oshiraseList = data.payload
          // 権限取得
          const kengenParam = {
            kinoId: self.currentKinoId,
            groupId: self.currentKengenGroupCd
          }
          self.$store.dispatch('DDMasters/getKengen', kengenParam).then((kengen) => {
            // ボタン設定
            if (kengen.kengenKbn === '10') {
              // 読取モード
              self.modeKengen = 0
              self.dashDashBoardDisp = false
            } else {
              // フルアクセス
              self.modeKengen = 2
              self.dashDashBoardDisp = true
              self.getUriageInfo()
              self.getDayByDayInfo()
              self.getUriageChartInfo()
            }
            self.$nextTick(() => {
              effects.loadComplete()
            })
          })
        })
      })
    },
    settingButtonState: function (e) {
      console.log('settingButtonState')
      if (this.kengenGroupCd === '01') {
        this.OshiraseUpdateButtonDisp = true
        this.SystemOshiraseUpdateButtonDisp = true
      }
    },

    onRoute: function (e) {
      this.$store.dispatch('system/clearMessage')
    },
    onClick: function () {
      effects.loadStart()
      window.setTimeout(effects.loadComplete, 3000)
    },
    onClickInformation: function (locate) {
      if (locate.match(/^#/)) {
        document.getElementById(locate.replace(/^#/, '')).scrollIntoView()
      }
    },
    onTransitionToSharyo: function (id) {
      this.$router.push({ name: 'mst-sharyo-edit', params: { id: id } })
    },
    onTransitionToJinin: function (id) {
      this.$router.push({ name: 'mst-jinin-edit', params: { id: id } })
    },
    // ------------------------------
    //
    // ------------------------------
    isLatest: function (targetDate) {
      // １週間前の日付を取得
      var xDate = this.get1WeekAgoDay().replaceAll('/', '')

      // 日付比較
      var tDate = targetDate.substr(0, 10).replaceAll('-', '')
      if (xDate < tDate) {
        return true
      }
      return false
    },
    get1WeekAgoDay: function () {
      var date = new Date()
      date.setDate(date.getDate() - 7)
      const Y = date.getFullYear()
      const M = ('00' + (date.getMonth() + 1)).slice(-2)
      const D = ('00' + date.getDate()).slice(-2)

      return Y + '/' + M + '/' + D
    },
    getAfterDay: function (num) {
      var date = new Date()
      date.setDate(date.getDate() + num)
      const Y = date.getFullYear()
      const M = ('00' + (date.getMonth() + 1)).slice(-2)
      const D = ('00' + date.getDate()).slice(-2)

      return Y + '/' + M + '/' + D
    },
    getUsanaviInfo: function () {
      this.HttpClient
        .get(`/api/v1/MstUsanaviKokyaku/ChangeStatusJininId?id=${this.userId}`)
        .then((data) => {
          if (data.payload) {
            const usanaviInfo = data.payload
            if (usanaviInfo.riyokigenTsuchiFlg) {
              modals.showWarning('うさナビDrive Door Liteの利用可能期間が' + filter.dateFormatter(usanaviInfo.drivedoorRiyoEndYmd) + 'に終了となります。<br>利用期間の延長をご希望の場合はサポートセンターまでお問い合わせ下さい。')
            }
          }
        })
    },

    /**
     * 売上
     */
    onClickUriagePrevMonth () {
      this.uriageTargetYmIndex += 1
      const self = this
      this.$nextTick().then(() => {
        self.getUriageInfo()
        self.getUriageChartInfo()
      })
    },
    onClickUriageCurrentMonth () {
      this.uriageTargetYmIndex = 12
      const self = this
      this.$nextTick().then(() => {
        self.getUriageInfo()
        self.getUriageChartInfo()
      })
    },
    onClickUriageNextMonth () {
      this.uriageTargetYmIndex -= 1
      const self = this
      this.$nextTick().then(() => {
        self.getUriageInfo()
        self.getUriageChartInfo()
      })
    },
    onChangeTargetYmdType: function (p) {
      const self = this
      self.targetYmdType = p
      this.$nextTick().then(() => {
        self.getUriageInfo()
        self.getDayByDayInfo()
        self.getUriageChartInfo()
      })
    },
    getUriageInfo: function () {
      const self = this
      this.$nextTick().then(() => {
        self.$refs.uriageSummaryDisp.searchUriageSummary(self.uriageTargetYmList, self.uriageTargetYmIndex, self.targetYmdType)
      })
    },

    /**
     * 日毎実績
     */
    getDayByDayInfo: function () {
      const self = this
      this.$nextTick().then(() => {
        self.$refs.uriageDayByDayDisp.searchDayByDaySummary(self.targetYmdType)
      })
    },

    /**
     * 売上チャート
     */
    getUriageChartInfo: function () {
      const self = this
      this.$nextTick().then(() => {
        self.$refs.uriageChartDisp.searchUriageChartSummary(self.targetYmdType)
      })
    },

    /**
     * 日付計算
     */
    monthAdd: function (num, date) {
      if (typeof date === 'string') {
        var converted = Date.parse(date)
        var myDate = new Date(converted)
        if (isNaN(myDate)) {
          var arys = date.split('/')
          myDate = new Date(arys[0], --arys[1], arys[2])
        }
        date = myDate
      }
      var resultDate = new Date(date.getTime())
      resultDate.setMonth(date.getMonth() + num)
      if (date.getDate() > resultDate.getDate()) {
        resultDate.setDate(0)
      }

      return ('000' + resultDate.getFullYear()).slice(-4) + '/' + ('0' + (resultDate.getMonth() + 1)).slice(-2) + '/01'
    },
    getAfterDaysfromToday: function (beforeDay) {
      var date = new Date()
      date.setDate(date.getDate() + beforeDay)
      const Y = date.getFullYear()
      const M = ('00' + (date.getMonth() + 1)).slice(-2)
      const D = ('00' + date.getDate()).slice(-2)

      return Y + '/' + M + '/' + D
    },

    /**
     * お知らせ編集
     */
    setRecord: function (e, hasseimotoKbn) {
      const pHasseimotoKbn = [undefined, null, ''].includes(hasseimotoKbn) ? null : hasseimotoKbn
      const tmp = {
        id: e ? e.id : 0,
        kaishaCd: e ? e.kaishaCd : this.currentKaishaCode,
        tekiyoStartYmdString: e ? e.tekiyoStartYmdDisp : date.getCurrentDate(),
        tekiyoEndYmdString: e ? e.tekiyoEndYmdDisp : this.getAfterDaysfromToday(14),
        title: e ? e.title : IMPORTAMT,
        oshiraseShosai: e ? e.oshiraseShosai : '',
        hasseimotoKbn: e ? e.hasseimotoKbn : pHasseimotoKbn,
        linkUrl: e ? e.linkUrl : '',
        updDate: e ? e.updDate : date.getCurrentDate()
      }
      this.rec = Object.assign({}, tmp)
    },
    showSloganDialog: function (e) {
      this.setRecord(e, null)
      this.$modal.show('slogan-edit-dialog')
    },
    onSloganEditCloseButtonClick: function () {
      this.$modal.hide('slogan-edit-dialog')
    },
    showSystemOshiraseDialog: function (e) {
      this.showSystemOshirase = true
    },
    onSystemOshiraseCloseButtonClick: function () {
      this.showSystemOshirase = false
    },
    showOshiraseEditDialog: function (e) {
      this.setRecord(e, COMPANY_MESSAGE)
      this.$modal.show('oshirase-edit-dialog')
    },
    onOshiraseEditCloseButtonClick: function () {
      this.$modal.hide('oshirase-edit-dialog')
    },
    onSaveButtonClick: function (dialog) {
      const self = this
      const opt = {
        registerRequestPromise: self.registerPromise,
        registerResponsePromise: (data) => {
          return new Promise(resolve => {
            self.rec.id = data.payload.id
            // 再検索
            self.HttpClient.get('/api/v1/MsysMenuOshirase/GetAll', null).then((data) => {
              self.oshiraseList = data.payload
              this.$nextTick(() => {
                self.$modal.hide(dialog)
                effects.loadComplete()
              })
            })
            resolve()
          })
        },
        getIdMethod: () => {
          return self.rec.id
        },
        continuousInputInitializePromise: (id) => {
          return new Promise(resolve => {
            resolve()
          })
        },
        getTransitionBackParams: function () {
          return {
            actionId: 0,
            param: { id: self.rec.id }
          }
        },
        isUpdateModeMethod: function () {
          return true
        },
        isNoRefreshModeMethod: function () {
          return true
        },
        isNoMessageModeMethod: function () {
          return true
        }
      }

      this.register(opt)
    },
    registerPromise: function () {
      // 日付項目再設定
      this.rec.infoYmd = this.rec.tekiyoStartYmdString
      this.rec.tekiyoStartYmd = this.rec.tekiyoStartYmdString
      this.rec.tekiyoEndYmd = this.rec.tekiyoEndYmdString
      // システムお知らせの場合に会社コードを上書き
      if (this.rec.hasseimotoKbn === SYSTEM_MESSAGE) this.rec.kaishaCd = '****'

      let f
      console.log('registerPromise', this.rec.id)
      if (this.rec.id === 0) {
        f = this.HttpClient.post('/api/v1/MsysMenuOshirase/Create', this.rec)
      } else {
        f = this.HttpClient.put(`/api/v1/MsysMenuOshirase/Update?id=${this.rec.id}`, this.rec)
      }
      return f
    },
    // 入力チェック
    registerValidate: function () {
      return true
    },
    getSystemConfigInfo: function () {
      var systemConfig = this.systemConfigList.filter((t) => {
        return t.configName === 'ddboard_target_ymd_type'
      })
      if (systemConfig.length > 0) {
        return systemConfig[0].configValue1 ?? '01'
      } else {
        return '01'
      }
    }
  }
}
